// components/NotFoundPage.js
import React from 'react';

const NotFoundPage = () => {
  return (
    <div
      style={{
        textAlign: 'center',
        padding: '50px',
        backgroundColor: '#f8f9fa',
        minHeight: 'calc(100vh - 8rem)', // Consider navbar and footer height
      }}
    >
      <h1 style={{ color: '#046655' }}>404 Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <a href="/" style={{ color: '#046655', textDecoration: 'none' }}>Go Back Home</a>
    </div>
  );
};

export default NotFoundPage;
